export default __webpack_public_path__ + "static/media/about-mobile.07abf48f.webp";